// import type from './ActionType';
import { injectTokenURL } from '../util/util';
import axios from 'axios';
import config from '../config';
import { IEstado } from '../store/Models'
import { Dispatch } from 'redux';

export const SET_ESTADOS = "SET_ESTADOS";

    
export interface IEstadoAction {
    type: typeof SET_ESTADOS,
    estados: Array<IEstado>
}

export const setCidades = (estados: Array<IEstado>): IEstadoAction => {
    return {
        type: SET_ESTADOS,
        estados
    };
}

// faz a leitura da lista de cidade do estado e coloca no store
export const doLeEstadosAction = () => {
    return async (dispatch: Dispatch, getState: any) => {

        const state = getState();
        //const offlineCidades: Array<ICidade> = state.cidadeReducer.cidades;

        // pega o token do state 
        const token = state.appReducer.token;
        // injeta o token na chamada
        const url = injectTokenURL(config.url_estados_list, token); 

        return new Promise(async (resolve, reject) => {
            try {
                const response = await axios.post(url, {});
                // compara se a lista recebida é diferente da lista offline, se não for, não recarrega o store
                await dispatch(setCidades(response.data));
                resolve(response.data);
            } catch (e) {
                console.error(e.message);
                reject(e);
            }
        });

    }
}

